/*
 * @Descripttion:
 * @version:
 * @Author: 周志国
 * @Date: 2025-09-09 14:27:47
 * @LastEditors: 周志国
 * @LastEditTime: 2025-09-11 11:17:42
 * @changeLog:
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/Plane/interface.ts
 */
import type { Mesh } from '@anov/3d-core'
import type { options } from './types'
export interface IPlane {
  /**
   * 创建平面
   * @param options - 参数配置
   */
  createPlane: (options: options) => Mesh
  /**
 * 更新平面
 * @param options - 参数配置
 * @returns
 */
  updatePlane: (options: options) => void
  /**
   * 销毁平面
   */
  destroy: () => void
}